import { Rail } from "./Rail";

const QUOTES = [
  "„Kein Warten bei der Behörde – ich erledige alles am selben Tag“",
  "„Persönlicher Ansprechpartner, faire Festpreise“",
  "„Ich mache das seit vielen Jahren, kenne jede Regel“",
];

export const Why = () => (
  <Rail id="warum" label="02 · Warum ich" className="shade-paper-alt edge-shadow text-ink">
    <div className="grid md:grid-cols-[1fr_300px] gap-8 sm:gap-12">
      <ul className="space-y-5 sm:space-y-8" data-testid="why-list">
        {QUOTES.map((q, i) => (
          <li key={q} className={`dp text-[26px] leading-tight sm:text-3xl md:text-4xl ${i === 2 ? "text-plate" : ""}`}>{q}</li>
        ))}
      </ul>
      <figure className="relative aspect-[16/10] sm:aspect-[4/5] bg-stone overflow-hidden soft-photo">
        <img
          src="/img/schluessel.jpg"
          alt="Autoschlüssel und Unterlagen"
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <figcaption className="absolute bottom-0 left-0 right-0 lb text-white bg-gradient-to-t from-black/60 to-transparent p-4 pt-12">
          Persönlich betreut
        </figcaption>
      </figure>
    </div>
  </Rail>
);
